module.exports = __webpack_public_path__ + "assets/img/freeFive.86de5b1f.png";